import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetRosterGroupResponse,
  GetRosterGroupByIdResponse,
  PostRosterGroupResponse,
  PutRosterGroupResponse,
} from '../response/roster-group';
import { PostRosterGroupRequest, PutRosterGroupRequest, RosterReorderRequest } from '../request/roster-group';

export class RosterGroupService {
  static getRosterGroups(params?: QueryParams) {
    return apiClient.get<GetRosterGroupResponse>(buildApiUrl('/api/v1/team/roster-group'), params);
  }

  static getRosterGroupById(id: string) {
    return apiClient.get<GetRosterGroupByIdResponse>(buildApiUrl('/api/v1/team/roster-group/:id', { id }), undefined);
  }

  static postRosterGroup(data: PostRosterGroupRequest) {
    return apiClient.post<PostRosterGroupResponse>(buildApiUrl('/api/v1/team/roster-group'), data);
  }

  static putRosterGroup(id: string, data: PutRosterGroupRequest) {
    return apiClient.update<PutRosterGroupResponse>(buildApiUrl('/api/v1/team/roster-group/:id', { id }), data);
  }

  static deleteRosterGroup(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/team/roster-group/:id', { id }), undefined);
  }

  static reorderRosterGroups(data: RosterReorderRequest) {
    return apiClient.update<void>(buildApiUrl('/api/v1/team/roster/reorder-groups'), data);
  }
}
